import { defaultAboutPage } from "../defaultData";
import { readDb, writeDb } from "../database";

function mergeAboutPage(raw) {
  return { ...JSON.parse(JSON.stringify(defaultAboutPage)), ...(raw || {}) };
}

function ok(data, msg = "ok") {
  return { code: 0, msg, data };
}

export function getMenus() {
  return ok(readDb().menus);
}

export function saveMenus(payload) {
  const db = readDb();
  db.menus = Array.isArray(payload) ? payload : [];
  writeDb(db);
  return ok(db.menus, "保存成功");
}

export function getBasicInfo() {
  return ok(readDb().basicInfo);
}

export function saveBasicInfo(payload) {
  const db = readDb();
  db.basicInfo = { ...db.basicInfo, ...(payload || {}) };
  writeDb(db);
  return ok(db.basicInfo, "保存成功");
}

export function getPartners() {
  return ok(readDb().partners);
}

export function savePartners(payload) {
  const db = readDb();
  db.partners = Array.isArray(payload) ? payload : [];
  writeDb(db);
  return ok(db.partners, "保存成功");
}

export function getProducts() {
  return ok(readDb().products);
}

export function saveProducts(payload) {
  const db = readDb();
  db.products = Array.isArray(payload) ? payload : [];
  writeDb(db);
  return ok(db.products, "保存成功");
}

export function getCoreFeatures() {
  const raw = readDb().coreFeatures;
  return ok(Array.isArray(raw) ? raw : []);
}

export function saveCoreFeatures(payload) {
  const db = readDb();
  db.coreFeatures = Array.isArray(payload) ? payload : [];
  writeDb(db);
  return ok(db.coreFeatures, "保存成功");
}

export function getAboutPage() {
  const db = readDb();
  return ok(mergeAboutPage(db.aboutPage));
}

export function saveAboutPage(payload) {
  const db = readDb();
  db.aboutPage = mergeAboutPage({ ...(payload || {}) });
  writeDb(db);
  return ok(db.aboutPage, "保存成功");
}

export function getOfficialHome() {
  const db = readDb();
  return ok({
    menus: db.menus,
    basicInfo: db.basicInfo,
    partners: db.partners,
    products: db.products,
    coreFeatures: db.coreFeatures || [],
    coreValues: Array.isArray(db.coreValues) ? db.coreValues : [],
    capabilityValues: Array.isArray(db.capabilityValues) ? db.capabilityValues : [],
    aboutPage: mergeAboutPage(db.aboutPage)
  });
}
